import React, { Component } from "react";
import {
    Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import * as Utilities from "./Utilities"

import { VWHaushalt } from './VWHaushaltsComp';
import { VMHaushalt } from './VMHaushaltsComp';
import { WeitereFinanzdaten } from './WeitereFinanzdatenComp';

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import { VBTab } from './VBTabComp';

import * as QueryString from "query-string";

type State = {
    ready: boolean;        
    activeMainTab: string,
    selectedGLEbene: string;    
    isVisible: boolean;
    showWF: boolean;
    showVWH: boolean;
    showVMH: boolean;
}

type Props = {    
    kunde: number,
    gemeinde: number,
    jahr: number,
    plantyp: number,
    planstufe: number,
    verwaltungsansicht: boolean,
    uhconfig: KSLPlusAPI.UhConfigModel | undefined,
    massnahmen: KSLPlusAPI.Massnahman[],
    settings: KSLPlusAPI.SettingsModel,
    isVisible: boolean,
    query: string | undefined,
    onReady: () => void
}



export class Finanzdaten extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        
        this.dataSets = []; 
        this.vbtabs = [];       

    }

    static defaultProps = {        
        onReady: () => { }
    }

    node: any;
    
    dataSets: KSLPlusAPI.Datensaetze[];    
    vbtabs: KSLPlusAPI.Vbtab[];

    state: State = {
        ready: true,        
        activeMainTab: "1",
        selectedGLEbene: "",
        isVisible: false,
        showWF: false,
        showVWH: false,
        showVMH: false
    }    

    handleSelectHHEbene = (ebenenNum: string) => {           
        this.setState({selectedGLEbene: ebenenNum} );        
    } 

    componentDidUpdate(prevProps: Props) {
        if (prevProps.isVisible !== this.props.isVisible && this.props.isVisible !== this.state.isVisible) {
            this.setState({ activeMainTab: "1" });
            this.parseParams();
        }

    }

    componentDidMount() {
        this.parseParams();
    }


    parseParams = () => {
        if (!this.props.query)
            return;

        const params = QueryString.parse(this.props.query);


        if (params.fdt != null) {
            if (Array.isArray(params.fdt))
                this.setState({ activeMainTab: params.fdt[0] });
            else
                this.setState({ activeMainTab: params.fdt });
        }
    }
    
                     
    render() {
                

        return (
            <div className="kslplus-haushaltstab-wrapper-middle">  
                <Nav tabs>     
                    {this.state.showVWH &&
                        <>
                            <NavItem id="kslplus-tab-verwaltungshaushalt-detailliert">
                                <NavLink active={this.state.activeMainTab === "1"} onClick={() => this.setState({ activeMainTab: "1" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "1" }); }}>
                                    <div className="kslplus-reiter-text-hauptzeile">Verwaltungshaushalt detailliert</div>
                                </NavLink>
                            </NavItem>
                            {Utilities.createTTItem(this.props.settings, "verwaltungshaushalt-detailliert")}
                        </>
                    }
                    {this.state.showVMH &&
                        <>
                            <NavItem id="kslplus-tab-vermögenshaushalt-detailliert">
                                <NavLink active={this.state.activeMainTab === "2"} onClick={() => this.setState({ activeMainTab: "2" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "2" }); }}>
                                    <div className="kslplus-reiter-text-hauptzeile">Vermögenshaushalt detailliert</div>
                                                
                                </NavLink>
                            </NavItem>    
                            {Utilities.createTTItem(this.props.settings, "vermögenshaushalt-detailliert")}
                        </>
                    }
                    {this.state.showWF &&
                        <NavItem id="kslplus-tab-weitere-finanzdaten">
                            <NavLink active={this.state.activeMainTab === "3"} onClick={() => this.setState({ activeMainTab: "3" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "3" }); }}>
                                <div className="kslplus-reiter-text-hauptzeile">Weitere Finanzdaten</div>
                            </NavLink>
                        </NavItem>
                    }
                    {this.state.showWF && Utilities.createTTItem(this.props.settings, "weitere-finanzdaten")}
                </Nav>
                
                <TabContent activeTab={this.state.activeMainTab}>                    
                                                                
                    <TabPane tabId="1">

                        <VWHaushalt kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} plantyp={this.props.plantyp} planstufe={this.props.planstufe} uhconfig={this.props.uhconfig} settings={this.props.settings} onSelGLChange={this.handleSelectHHEbene} selectedGL={this.state.selectedGLEbene} massnahmen={this.props.massnahmen} isVisible={this.props.isVisible && this.state.activeMainTab === "1"} verwaltungsansicht={this.props.verwaltungsansicht} query={this.props.query} onReady={() => { this.setState({ showVWH: true }); this.props.onReady(); }} />
                                        
                    </TabPane>
                    <TabPane tabId="2">
                        <VMHaushalt kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} plantyp={this.props.plantyp} planstufe={this.props.planstufe} uhconfig={this.props.uhconfig} settings={this.props.settings} onSelGLChange={this.handleSelectHHEbene} selectedGL={this.state.selectedGLEbene} massnahmen={this.props.massnahmen} isVisible={this.props.isVisible && this.state.activeMainTab === "2"} verwaltungsansicht={this.props.verwaltungsansicht} query={this.props.query} onReady={() => { this.setState({ showVMH: true }); this.props.onReady(); }} />
                            
                    </TabPane>
                    <TabPane tabId="3">
                        <WeitereFinanzdaten kunde={this.props.kunde} gemeinde={this.props.gemeinde} jahr={this.props.jahr} plantyp={this.props.plantyp} planstufe={this.props.planstufe} settings={this.props.settings} massnahmen={this.props.massnahmen} isVisible={this.props.isVisible && this.state.activeMainTab === "3"} uhconfig={this.props.uhconfig} verwaltungsansicht={this.props.verwaltungsansicht} query={this.props.query} onReady={() => { this.setState({ showWF: true }); this.props.onReady(); }} />                            
                    </TabPane>                    
                </TabContent>
                               
            </div>
        );
    }
}